import React, { PureComponent } from 'react';

class ButtonEditar extends PureComponent {
    constructor(props) {
        super(props);
        this.onClickEditarCobranza = this.onClickEditarCobranza.bind(this);
    }

    onClickEditarCobranza(event) {
        this.props.editar(this.props.cobranza);
    }

    render() {  
        return (<a className="clickable none-text-decoration glyphicon glyphicon-edit" aria-hidden="true" onClick={this.onClickEditarCobranza}></a>);
    }
}

export default ButtonEditar;